import { render, staticRenderFns } from "./RailroadCrossing.vue?vue&type=template&id=cb2b79e4&scoped=true"
import script from "./RailroadCrossing.vue?vue&type=script&lang=js"
export * from "./RailroadCrossing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2b79e4",
  null
  
)

export default component.exports